export const REQUEST_COUNTS_CHANGED = 'erp-requests-changed'

export function notifyRequestChange(response) {
  window.dispatchEvent(new Event(REQUEST_COUNTS_CHANGED))
  return response
}
